import Reveal from '@/components/base/Reveal';
import { marketMainImage, marketSupportImages } from '../data';

export default function MarketStory() {
  return (
    <section id="market" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="flex items-center justify-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-primary-500">
            <span className="h-px w-8 bg-primary-500/50" aria-hidden="true" />
            Real • Traditional • Community
            <span className="h-px w-8 bg-primary-500/50" aria-hidden="true" />
          </p>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl leading-[1.12] font-medium text-foreground-950">
            From Our Market to Your Community
          </h2>
          <p className="mt-5 text-[15px] md:text-base leading-relaxed text-foreground-700">
            Discover the people, textiles and traditional clothing behind SRM Textiles — a
            genuine real-world presence built on heritage, craft and community.
          </p>
        </Reveal>

        {/* Editorial collage */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5 items-stretch">
          <Reveal className="md:col-span-7">
            <div className="img-zoom rounded-lg overflow-hidden h-full">
              <img
                src={marketMainImage}
                alt="SRM Textiles traditional Indian textile market stall with colourful sarees and fabrics on display"
                className="h-[380px] md:h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>
          <div className="md:col-span-5 grid grid-cols-2 gap-5">
            {marketSupportImages.map((img, i) => (
              <Reveal key={img} delay={i * 100} className={i === 0 ? 'col-span-2' : ''}>
                <div className="img-zoom rounded-lg overflow-hidden">
                  <img
                    src={img}
                    alt="Authentic market photograph of traditional Indian textiles and sarees at an SRM Textiles stall"
                    className="h-40 md:h-44 w-full object-cover object-top"
                  />
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal className="mt-12 flex flex-col items-center justify-between gap-6 md:flex-row">
          <blockquote className="max-w-xl font-heading text-2xl md:text-3xl italic leading-snug text-foreground-800">
            &ldquo;Every fold tells a story of family, celebration and tradition — carried
            from the market to your home.&rdquo;
          </blockquote>
          <a
            href="#story"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-6 py-3 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-50"
          >
            Discover Our Story
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}